
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqFpJ7zZunI5A7Dp_NV7wsP6CX6kSAj7ju2sdusOtPG9UMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/faq.vue?macro=true";
import { default as aboutSWNOLZPtU5avmHfApKU8w3cDKQVvoGrnwYTczYwSRPAMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/about.vue?macro=true";
import { default as index_27SDZpmn74u6vrXE87yudPi6Hrgk9bmkytfmdfUIrcMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/index.vue?macro=true";
import { default as offerdRdXuH31ugQJ82yjpgUhqV78hZWNQqG_M8FK94Fw9m0Meta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/offer.vue?macro=true";
import { default as privacyex5N_f_6GEB7MFXHh7hpqsaVHBZEiLZelviMV3G_h4cMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/privacy.vue?macro=true";
import { default as returns3r1Wlj6_CFo3wgI2DA2F_CCATqK9ey464uvLVnypNtwMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/returns.vue?macro=true";
import { default as agreementr_sNrO7_BB_LOfU0KB6X3S6IXgOVpT2ZKTfrK1lijmwMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/agreement.vue?macro=true";
import { default as indexqaaIPwIJIj_5z3Td2icA6TRWlRZAQdMrAQzl_VN9HygMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Cart/pages/cart/index.vue?macro=true";
import { default as index9LprPH1a3yV6jdmkSA_QhexZZkk8_Db398cRnDjYzN0Meta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/index.vue?macro=true";
import { default as indexjsVPs6J9GPzFt8b5XaZ9HWLJ5Vuf92OgZo60XYKSCmEMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/orders/index.vue?macro=true";
import { default as _91id_93to_u09mOgptV19QWiz57feUHmyqGxBntfMyfrCxB2VkMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/product/[id].vue?macro=true";
import { default as indexhXiyp_5157uD8podVmK0A1XzTz7xjKfEM9DZAa23w68Meta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/search/index.vue?macro=true";
import { default as data_45transferbZmxx9eZ5zVsiizX6KJdJ_kf5ureuSXZtZ9_ghMXI14Meta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/data-transfer.vue?macro=true";
import { default as indextOm9DgNuYM8zExLXb2vs3J3OsOjGiBd5fTU_jQj6srEMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/index.vue?macro=true";
import { default as _91tab_937eE7oMcyv_DRFs0XUPqA6skrqXXU_4ZZIm_17H3LtpsMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders/[tab].vue?macro=true";
import { default as OrderskRhHIvSVew4rSayB95HgdF_9VFnV7_AKheSwf_HksV0Meta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders.vue?macro=true";
import { default as _91id_93_lZosuKCwXpKMnKhATiPf9r05fchGnKPWbdIJlfnGIcMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Detail/[id].vue?macro=true";
import { default as indexSECpZBY6WHddOSyQRav2iH0ZYkaF7ONnAP7UVXjSmTQMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Create/index.vue?macro=true";
import { default as indexdMtAz7q_HKJvqdY4MH42WCr7odDzK7SQCJ2FNvThKngMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/Edit/index.vue?macro=true";
import { default as indexWd_pDMiVETVKTo3nc7gh6CRPudYrEjGHntJvjUlQ7_UMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Loyalty/pages/Profile/Loyalty/index.vue?macro=true";
import { default as indexyhHgpnLzSmH0ubnaf5IbYNL4df4_vlTCaw4nL_jTx_4Meta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Fail/index.vue?macro=true";
import { default as indexTfHs0Vczl5rsWRoGnRbWi_SY1xv0VDs4Rf0dYrgsn0gMeta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/catalog/[[category]]/index.vue?macro=true";
import { default as indexM4sXOm_mQw4_CWYGjNrNHq94lf4SsJCe6AjNBFSSmb0Meta } from "/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Success/index.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/faq.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/about.vue")
  },
  {
    name: "ProductsIndex",
    path: "/",
    redirect: "/catalog/",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/index.vue")
  },
  {
    name: "offer",
    path: "/offer",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/offer.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/privacy.vue")
  },
  {
    name: "returns",
    path: "/returns",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/returns.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/agreement.vue")
  },
  {
    name: "CartIndex",
    path: "/cart",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Cart/pages/cart/index.vue")
  },
  {
    name: "OrderIndex",
    path: "/Order",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/index.vue")
  },
  {
    name: "OrdersIndex",
    path: "/orders",
    meta: indexjsVPs6J9GPzFt8b5XaZ9HWLJ5Vuf92OgZo60XYKSCmEMeta || {},
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/orders/index.vue")
  },
  {
    name: "ProductsDetails",
    path: "/product/:id()",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/product/[id].vue")
  },
  {
    name: "ProductsSearch",
    path: "/search",
    meta: indexhXiyp_5157uD8podVmK0A1XzTz7xjKfEM9DZAa23w68Meta || {},
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/search/index.vue")
  },
  {
    name: "data-transfer",
    path: "/data-transfer",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/data-transfer.vue")
  },
  {
    name: "ProfileIndex",
    path: "/Profile",
    meta: indextOm9DgNuYM8zExLXb2vs3J3OsOjGiBd5fTU_jQj6srEMeta || {},
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/index.vue")
  },
  {
    name: "Profile-Orders",
    path: "/Profile/Orders",
    redirect: "/orders",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders.vue"),
    children: [
  {
    name: "ProfileOrdersTab",
    path: ":tab()",
    redirect: "/orders",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders/[tab].vue")
  }
]
  },
  {
    name: "OrderDetail",
    path: "/Order/Detail/:id()",
    meta: _91id_93_lZosuKCwXpKMnKhATiPf9r05fchGnKPWbdIJlfnGIcMeta || {},
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Detail/[id].vue")
  },
  {
    name: "OrderCreate",
    path: "/Order/Create",
    meta: indexSECpZBY6WHddOSyQRav2iH0ZYkaF7ONnAP7UVXjSmTQMeta || {},
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Create/index.vue")
  },
  {
    name: "ProfileEdit",
    path: "/Profile/Edit",
    redirect: "/profile",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/Edit/index.vue")
  },
  {
    name: "LoyaltyIndex",
    path: "/Profile/Loyalty",
    redirect: "/profile",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Loyalty/pages/Profile/Loyalty/index.vue")
  },
  {
    name: "OrderPaymentFail",
    path: "/Order/Payment/Fail",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Fail/index.vue")
  },
  {
    name: "ProductsCatalog",
    path: "/catalog/:category?",
    meta: indexTfHs0Vczl5rsWRoGnRbWi_SY1xv0VDs4Rf0dYrgsn0gMeta || {},
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/catalog/[[category]]/index.vue")
  },
  {
    name: "OrderPaymentSuccess",
    path: "/Order/Payment/Success",
    component: () => import("/builds/skuby/miniapp-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Success/index.vue")
  }
]